import React from 'react';
import './Componenst.css';
import PersonModel from '../models/PersonModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import persons from '../../img/profile.png';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createPerson, createTraitor, showError } from '../ViewCreator';

function Person({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false}) {

  const personModel = new PersonModel();


  const clearSubmit = () => {
    document.getElementById('lastName').value = '';
    document.getElementById('firstName').value = '';
    document.getElementById('middleName').value = '';
    document.getElementById('bDate').value = '';
    document.getElementById('bLocation').value = '';
    document.getElementById('citizen').value = '';
    document.getElementById('nationality').value = '';
    document.getElementById('nikName').value = '';
    document.getElementById('criminal').value = '';
    document.getElementById('desc').value = '';
    personModel.lastName = ''
    personModel.firstName = ''
    personModel.middleName = ''
    personModel.bDate = ''
    personModel.bLocation = ''
    personModel.citizen = ''
    personModel.nationality = ''
    personModel.nikName = ''
    personModel.criminal = ''
    personModel.desc = ''
    if (searchModel != undefined) {
      searchModel.person.lastName = ''
      searchModel.person.firstName = ''
      searchModel.person.middleName = ''
      searchModel.person.bDate = ''
      searchModel.person.bLocation = ''
      searchModel.person.citizen = ''
      searchModel.person.nationality = ''
      searchModel.person.nikName = ''
      searchModel.person.criminal = ''
      searchModel.person.desc = ''
    }
  }

  const addSubmit = () => {
    if (personModel.lastName == undefined || personModel.lastName == ''){
      showError('Прізвище об\'єкта не може бути пустим')
      return;
    }

    if (personModel.firstName == undefined || personModel.firstName == ''){
      showError('Ім\'я об\'єкта не може бути пустим')
      return;
    }

    if (personModel.middleName == undefined || personModel.middleName == ''){
      showError('По батькові об\'єкта не може бути пустим')
      return;
    }

    if (personModel.bDate == undefined || personModel.bDate == ''){
      showError('Рік народження об\'єкта не може бути пустим')
      return;
    }

    if (personModel.criminal == undefined || personModel.criminal == ''){
      personModel.criminal = 'Ні'
    }

    isUniq()


  }

  const isUniq = () => {
    var path = ip + '/api/person/search';
    personModel.searchModel = new SearchModel()
    var pp = new PersonModel();
    pp.firstName = personModel.firstName
    pp.lastName = personModel.lastName
    pp.middleName = personModel.middleName
    pp.bDate = personModel.bDate
    var bd = encryptAes(JSON.stringify(pp))
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
           showError(result.msg)
         

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          if (result.data.length > 0) {
            Swal.fire({
              title: 'Запис уже існує',
              //text: "Оновити інформацію?",
              icon: 'warning',
              html:
              'Запис з такими даними вже існує, Ви можете ' +
              '<a href="/person?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a> ' +
              ' та змінити його або створити новий',
              showDenyButton: true,
              showCancelButton: true,
              confirmButtonText: 'Створити',
              denyButtonText: 'Оновити',

              background: '#2B2B2B',
              color: '#FFF'
            }).then((res) => {
              if (res.isConfirmed) {
                  addNewPersonForced()
                } else if (res.isDenied) {
                  personModel.id = result.data[0].id
                  updateNewPerson()
                }
              })
           
              sendSearch()
          } else {
            Swal.fire({
              title: 'Ви дійсно бажаєте створити новий запис',
              //text: "Оновити інформацію?",
              icon: 'question',
              html:
              '',
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: 'Створити',
              denyButtonText: 'Оновити',

              background: '#2B2B2B',
              color: '#FFF'
            }).then((result) => {
              addNewPerson()
              })
            
          }
        }
      })
  }

  const addNewPerson = () => {
    var path = ip + '/api/person/add';
    personModel.searchModel = new SearchModel()
    var bd = encryptAes(JSON.stringify(personModel))
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
           showError(result.msg)
          

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);
          if (isAdd) {
            addNew(result.data, 20000)
            clearSubmit()
          } else {
          window.open("/edit/person?id="+result.data, "_self")
          }
        }
      })
  }

  const addNewPersonForced = () => {
    var path = ip + '/api/person/addforced';
    personModel.searchModel = new SearchModel()
    var bd = encryptAes(JSON.stringify(personModel))
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
           showError(result.msg)
        

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);
          window.open("/edit/person?id="+result.data, "_self")
          
        }
      })
  }

  const updateNewPerson = () => {
    var path = ip + '/api/person/addData';
    personModel.searchModel = new SearchModel()
    var bd = encryptAes(JSON.stringify(personModel))
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
           showError(result.msg)


        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);
          window.open("/edit/person?id="+result.data.id, "_self")
          
        }
      })
  }

  const handleSubmit = (e) => {
    sendSearch();
    e.preventDefault();
  }

  const sendSearch = () => {
    var path = ip + '/api/person/search';
    personModel.searchModel = new SearchModel()
    var bd = encryptAes(JSON.stringify(personModel))
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
           showError(result.msg)
         

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          storeKey('test_data', result.key);

          var zz = []
        
          for (let index = 0; index < result.data.length; index++) {
            const tbl = document.createElement("table");
            const tblBody = document.createElement("tbody");
            const row = document.createElement("tr");
            const cell1 = document.createElement("td");
            cell1.className = "checkCell"
            const cell2 = document.createElement("td");



            var z = document.createElement('div'); // is a node
            var pers = result.data[index]
            var i = pers.id
            z.className = "listItem"
            if (pers.lastName == undefined) {
              z.innerHTML = "<p align=\"left\">" + pers.name + "<br>" + pers.bdate
            } else {
              z.innerHTML = "<p align=\"left\">" + pers.lastName + " " + pers.firstName + " " + pers.middleName + "<br>" + pers.bDate + "   " + pers.citizen;
            }
            z.style.display = "block";
             if (pers.name == undefined) {
               const cl = i => () => {
                 sendPerson(i)
               }
              // z.onclick = cl(pers.id)
             } else {
               const cl = i => () => {
                sendTraitor(i)
               }
              // z.onclick = cl(pers.id)
             }
 
             if (pers.name == undefined) {
               const dblcl = i => () => {
                sendPersonFullScreen(i)
               }
               z.ondblclick = dblcl(pers.id)
             } else {
               const dblcl = i => () => {
                sendTraitorFullScreen(i)
               }
               z.ondblclick = dblcl(pers.id)
             }
            var per = new PersonModel()
            per.id = pers.id
            z.value = per
            tbl.value = per

            //var d = document.createElement('div');
            //d.className = 'prevView'

            var element = new Image();



            if (pers.image == undefined) {
              element.src = persons
              element.className = 'prevImageSearchEmpty'



            } else {
              element.src = loading
              element.className = 'prevImageSearchEmpty'
              element.id = 'image' + pers.image
              getAvatar(pers.image)

              //element.src = 'data:image/png;base64,'+pers.image
              //element.className = 'prevImageSearch'
            }



            //d.appendChild(element)



            cell1.appendChild(element)
            cell2.appendChild(z)
            row.appendChild(cell1);
            row.appendChild(cell2);
            tblBody.appendChild(row);
            tbl.appendChild(tblBody);

            zz.push(tbl)

            //zz.push(z);
            // this.props.document.getElementById("items").appendChild(z);
            /*z.onclick = () => {
              
              document.getElementById(id).value = l[index]
              document.getElementById(id+"List").innerHTML = "";
            }*/
            //document.getElementById(id+"List").appendChild(z);

          }
          changeSearch(zz)
        }
      })
  }

  const sendPerson = (id) => {
   var path = ip + '/api/person/id';
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
    .then()
    .then(response => { return response.arrayBuffer() })
    .then((buffer) => {
      const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
      const text = decoder.decode(buffer);
      try {
        var result = JSON.parse(text);
         showError(result.msg)
       

      } catch (error) {
        const decryptedText = decryptAes(text);
        var result = JSON.parse(decryptedText);
        storeKey('test_data', result.key);

        
        var zz = []
                
                var pers = result.data
                var pe =  createPerson(pers)
                zz.push(pe)

               
                /*if(pers.addresses.length>0){
                  var adr = document.createElement('div');
                  adr.innerHTML = "<br><hr>Адреси:";
                  zz.push(adr)
                  for (let index = 0; index < pers.addresses.length; index++) {
                      var a = v.createAddressCollapsed(pers.addresses[index],index);
                      zz.push(a)
                  }
                }*/
                String.prototype.replaceAt = function(index, replacement) {
                  return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                }
                var spr =  document.createElement('div');
                spr.className = "spravka"
                
                spr.innerHTML = "<hr><p>"+pers.info.replace(/\r\n/g, "<p>"); 
                zz.push(spr)
               
                  setView(zz)
                
      }
    })
}

const sendTraitor = (id) => {
  var path = ip + '/api/traitor/id';
   var bd = encryptAes(id)
   const requestOptions = {
     headers: {
       'Content-Type': 'Content-type: text/html; charset=win1251'
     },
     credentials: 'include',
     uri: path,
     encoding: 'latin1',
     body: bd,
     method: 'POST'
   };
   fetch(path, requestOptions)
   .then()
   .then(response => { return response.arrayBuffer() })
   .then((buffer) => {
     const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
     const text = decoder.decode(buffer);
     try {
       var result = JSON.parse(text);
        showError(result.msg)
     

     } catch (error) {
       const decryptedText = decryptAes(text);
       var result = JSON.parse(decryptedText);
       storeKey('test_data', result.key);

       
       var zz = []
               
               var pers = result.data
               var pe =  createPerson(pers)
               zz.push(pe)

              
               /*if(pers.addresses.length>0){
                 var adr = document.createElement('div');
                 adr.innerHTML = "<br><hr>Адреси:";
                 zz.push(adr)
                 for (let index = 0; index < pers.addresses.length; index++) {
                     var a = v.createAddressCollapsed(pers.addresses[index],index);
                     zz.push(a)
                 }
               }*/
               String.prototype.replaceAt = function(index, replacement) {
                 return this.substr(0, index) + replacement + this.substr(index + replacement.length);
               }
               var spr =  document.createElement('div');
               spr.className = "spravka"
               
               spr.innerHTML = "<hr><p>"+pers.info.replace(/\r\n/g, "<p>"); 
               zz.push(spr)
              
                 setView(zz)
               
     }
   })
}

const sendPersonFullScreen = (id) => {
  window.open("/person?id="+id)
}

const sendTraitorFullScreen = (id) => {
  window.open("/traitor?id="+id)
}

  const getAvatar = async (id) => {
    var path = ip + '/files/avatar';
    personModel.searchModel = new SearchModel()
    var bd = encryptAes(id)
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
           showError(result.msg)
          

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);


          var a = document.getElementById('image' +id)
          a.src = 'data:image/png;base64,' + result.data
          a.className = 'prevImageSearch'
        }
      })

  }

  const handleKeyPress = (event) => {
    event = event || window.event;
    if (event.key === 'Tab') {
      closeAllHelp();
    }
    if (event.key === 'Enter') {
      closeAllHelp();
    }
    if (event.key === 'Escape') {
      closeAllHelp();
    }
  }
  const closeAllHelp = () => {
    var a = document.getElementsByClassName("list");
    for (let index = 0; index < a.length; index++) {
      a[index].innerHTML = "";
    }
  }
  const changedfield = (id) => {
    var input = document.getElementById(id)
    if (input != null) {
      if (input.value.length > 0) {
        document.getElementById(id + "List").innerHTML = "";
        sendHelp(input.value, id);
      } else {
        document.getElementById(id + "List").innerHTML = "";
      }
    }
  }

  const sendHelp = (value, id) => {
    var path = ip + '/api/help/';
    var bd = encryptAes(JSON.stringify({
      "value": value,
      "type": id
    }))
    const requestOptions = {
      headers: {
        'Content-Type': 'Content-type: text/html; charset=win1251'
      },
      credentials: 'include',
      uri: path,
      encoding: 'latin1',
      body: bd,
      method: 'POST'
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
          var result = JSON.parse(text);
           showError(result.msg)
         

        } catch (error) {
          const decryptedText = decryptAes(text);
          var result = JSON.parse(decryptedText);
          var l = result.data.list;
          for (let index = 0; index < l.length; index++) {
            var z = document.createElement('div'); // is a node
            z.className = "listItem"
            z.innerHTML = l[index];
            z.style.display = "block";
            z.href = "#";
            z.onclick = () => {

              document.getElementById(id).value = l[index]
              document.getElementById(id + "List").innerHTML = "";

              if (id == 'lastName') {
                personModel.lastName = l[index]
              }
              if (id == 'firstName') {
                personModel.firstName = l[index]
              }
              if (id == 'middleName') {
                personModel.middleName = l[index]
              }
              if (id == 'bLocation') {
                personModel.bLocation = l[index]
              }
              if (id == 'citizen') {
                personModel.citizen = l[index]
              }
              if (id == 'nationality') {
                personModel.nationality = l[index]
              }
              if (id == 'nikName') {
                personModel.nikName = l[index]
              }
              if (id == 'desc') {
                personModel.desc = l[index]
              }


            }
            document.getElementById(id + "List").appendChild(z);

          }
        }
      })








  }


  const lastNamechange = () => {
    personModel.lastName = document.getElementById('lastName').value
    changedfield('lastName');
  }
  const firstNamechange = () => {
    personModel.firstName = document.getElementById('firstName').value
    changedfield('firstName');
  }
  const middleNamechange = () => {
    personModel.middleName = document.getElementById('middleName').value
    changedfield('middleName');
  }
  const bDatechange = () => {
    personModel.bDate = document.getElementById('bDate').value
  }
  const bLocationchange = () => {
    personModel.bLocation = document.getElementById('bLocation').value
    changedfield('bLocation');
  }
  const citizenchange = () => {
    personModel.citizen = document.getElementById('citizen').value
    changedfield('citizen');
  }
  const nationalitychange = () => {
    personModel.nationality = document.getElementById('nationality').value
    changedfield('nationality');
  }
  const criminalchange = () => {
    personModel.criminal = document.getElementById('criminal').value
  }
  const nikNamechange = () => {
    personModel.nikName = document.getElementById('nikName').value
    changedfield('nikName');
  }
  const descchange = () => {
    personModel.desc = document.getElementById('desc').value
    changedfield('desc');
  }

  const handleFocus = (event) => {
    closeAllHelp()
  };

  return (
    <div>
      <button className="clear-button-right" onClick={clearSubmit}>Очистити
      </button>
      <button className="add-button-right" onClick={addSubmit}>Додати
      </button>
      <form onSubmit={handleSubmit} className="form">


        <input className="input-button-right" type="submit" value="Пошук" />



        <div id="descDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="desc" className="input-text" tabIndex="10" name="login" type="text" onChange={descchange} placeholder="Описання особи" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="descList" className="list" />
        </div>

        <div id="nikNameDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="nikName" className="input-text" tabIndex="9" name="login" type="text" onChange={nikNamechange} placeholder="Прізвисько" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="nikNameList" className="list" />
        </div>

        <div id="criminalDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="criminal" className="input-text" tabIndex="8" name="login" type="text" onChange={criminalchange} placeholder="Раніше засуджений" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="criminalList" className="list" />
        </div>

        <div id="nationalityDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="nationality" className="input-text" tabIndex="7" name="login" type="text" onChange={nationalitychange} placeholder="Національність" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="nationalityList" className="list" />
        </div>

        <div id="citizenDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="citizen" className="input-text" tabIndex="6" name="login" type="text" onChange={citizenchange} placeholder="Громадянин" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="citizenList" className="list" />
        </div>

        <div id="bLocationDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="bLocation" className="input-text" tabIndex="5" name="login" type="text" onChange={bLocationchange} placeholder="Місце народження" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="bLocationList" className="list" />
        </div>

        <div id="bDateDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="bDate" className="input-text" tabIndex="4" name="login" type="text" onChange={bDatechange} placeholder="Дата народження" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="bDateList" className="list" />
        </div>

        <div id="middleNameDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="middleName" className="input-text" tabIndex="3" name="login" type="text" onChange={middleNamechange} placeholder="По батькові" autoComplete="off" onFocus={handleFocus} />
          <div id="middleNameList" className="list" />
        </div>
        <div id="firstNameDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="firstName" className="input-text" tabIndex="2" name="login" type="text" onChange={firstNamechange} placeholder="Ім'я" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="firstNameList" className="list" />
        </div>
        <div id="lastNameDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
          <input id="lastName" className="input-text" tabIndex="1" name="login" type="text" onChange={lastNamechange} placeholder="Прізвище" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
          <div id="lastNameList" className="list" />
        </div>


      </form>
    </div>
  );
}

export default Person;